 
(function () {
  "use strict";

  /* =========================================================
     YUVAFLOWERS SIMPLE DELIVERY TEXT

     Tags checked:
     - Express Gifts
     - Courier Gifts

     Express:
     Earliest Delivery: Dynamic Time

     Courier:
     Earliest Dispatch: Today / Tomorrow
     ========================================================= */

  var CACHE_KEY = "yf_delivery_tags_v12";
  var CACHE_TTL = 30 * 60 * 1000;
  var REFRESH_INTERVAL = 60 * 1000;

  var tagCache = loadCache();
  var fetchPromises = Object.create(null);
  var observerTimer = null;
  var lastTimeKey = "";

  /* =========================================================
     CSS — SIMPLE TEXT ONLY
     ========================================================= */

  function injectCSS() {
    if (document.getElementById("yf-simple-delivery-css")) return;

    var style = document.createElement("style");
    style.id = "yf-simple-delivery-css";

    style.textContent =
      ".yf-delivery-text-wrap{" +
        "display:block;" +
        "width:100%;" +
        "margin:7px 0 3px;" +
        "line-height:1.35;" +
        "box-sizing:border-box;" +
      "}" +

      ".yf-delivery-text{" +
        "display:inline;" +
        "font-size:12px;" +
        "font-weight:600;" +
        "letter-spacing:.1px;" +
        "background:none;" +
        "border:0;" +
        "border-radius:0;" +
        "padding:0;" +
        "margin:0;" +
        "box-shadow:none;" +
      "}" +

    ".yf-delivery-text--express{" +
  "color:#111111;" +
"}" +

".yf-delivery-text--courier{" +
  "color:#111111;" +
"}" +

".yf-delivery-label{" +
  "font-weight:500;" +
  "color:#111111;" +
"}" +

".yf-delivery-value{" +
  "font-weight:600;" +
  "color:#169447;" +
  
"}" +

      ".yf-delivery-pdp{" +
        "margin-top:9px;" +
        "margin-bottom:6px;" +
      "}" +

      "@media screen and (max-width:749px){" +
        ".yf-delivery-text{" +
          "font-size:11.5px;" +
        "}" +
      "}";

    document.head.appendChild(style);
  }

  /* =========================================================
     CACHE
     ========================================================= */

  function loadCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};

      return parsed && typeof parsed === "object"
        ? parsed
        : {};
    } catch (error) {
      return {};
    }
  }

  function saveCache() {
    try {
      sessionStorage.setItem(
        CACHE_KEY,
        JSON.stringify(tagCache)
      );
    } catch (error) {}
  }

  function getCachedTags(handle) {
    var entry = tagCache[handle];

    if (!entry || !entry.tags || !entry.timestamp) {
      return null;
    }

    if (Date.now() - entry.timestamp > CACHE_TTL) {
      delete tagCache[handle];
      saveCache();
      return null;
    }

    return entry.tags;
  }

  function setCachedTags(handle, tags) {
    tagCache[handle] = {
      tags: tags,
      timestamp: Date.now()
    };

    saveCache();
  }

  /* =========================================================
     INDIA TIME
     ========================================================= */

  function getIndiaTime() {
    try {
      var parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      }).formatToParts(new Date());

      var hour = 0;
      var minute = 0;

      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === "hour") {
          hour = parseInt(parts[i].value, 10);
        }

        if (parts[i].type === "minute") {
          minute = parseInt(parts[i].value, 10);
        }
      }

      if (hour === 24) hour = 0;

      return {
        hour: hour,
        minute: minute
      };
    } catch (error) {
      var now = new Date();
      var utc =
        now.getTime() +
        now.getTimezoneOffset() * 60000;

      var indiaDate =
        new Date(utc + 330 * 60000);

      return {
        hour: indiaDate.getHours(),
        minute: indiaDate.getMinutes()
      };
    }
  }

  /* =========================================================
     DELIVERY TIMING
     ========================================================= */

  function getExpressText() {
    var hour = getIndiaTime().hour;

    /*
     8 PM to 11:59 PM
    */
    if (hour >= 20) {
      return "Tomorrow";
    }

    /*
     12 AM to 7:59 AM
    */
    if (hour < 8) {
      return "2-3 Hrs.";
    }

    /*
     7 PM to 7:59 PM
    */
    if (hour === 19) {
      return "Today";
    }

    switch (hour) {
      case 8:
        return "10 AM-1 PM";

      case 9:
        return "12 PM-1 PM";

      case 10:
        return "12 PM-3 PM";

      case 11:
        return "1 PM-4 PM";

      case 12:
        return "2 PM-5 PM";

      case 13:
        return "3 PM-6 PM";

      case 14:
        return "4 PM-7 PM";

      case 15:
        return "5 PM-8 PM";

      case 16:
        return "6 PM-9 PM";

      case 17:
        return "7 PM-10 PM";

      case 18:
        return "9 PM-12 AM";

      default:
        return "Today";
    }
  }

  function getCourierText() {
    return getIndiaTime().hour >= 20
      ? "Tomorrow"
      : "Today";
  }

  function getTimeKey() {
    return String(getIndiaTime().hour);
  }

  /* =========================================================
     TAG CHECKING
     ========================================================= */

  function normalizeTag(tag) {
    return String(tag || "")
      .trim()
      .toLowerCase();
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) {
      return tags.map(normalizeTag);
    }

    return String(tags || "")
      .split(",")
      .map(normalizeTag);
  }

  function hasTag(tags, wantedTag) {
    var tagList = normalizeTags(tags);
    var wanted = normalizeTag(wantedTag);

    for (var i = 0; i < tagList.length; i++) {
      if (tagList[i] === wanted) {
        return true;
      }
    }

    return false;
  }

  function getDeliveryType(tags) {
    /*
     Express gets priority if both tags exist.
    */
    if (
      hasTag(tags, "Express Gifts") ||
      hasTag(tags, "Express")
    ) {
      return "express";
    }

    if (
      hasTag(tags, "Courier Gifts") ||
      hasTag(tags, "Courier")
    ) {
      return "courier";
    }

    return "";
  }

  /* =========================================================
     FETCH PRODUCT TAGS
     ========================================================= */

  function fetchProductTags(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }

    var cachedTags = getCachedTags(handle);

    if (cachedTags) {
      return Promise.resolve(cachedTags);
    }

    if (fetchPromises[handle]) {
      return fetchPromises[handle];
    }

    fetchPromises[handle] = fetch(
      "/products/" + encodeURIComponent(handle) + ".js",
      {
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Product data fetch failed");
        }

        return response.json();
      })
      .then(function (product) {
        delete fetchPromises[handle];

        var tags =
          product && product.tags
            ? product.tags
            : [];

        setCachedTags(handle, tags);

        return tags;
      })
      .catch(function () {
        delete fetchPromises[handle];
        return null;
      });

    return fetchPromises[handle];
  }

  /* =========================================================
     TEXT HTML
     ========================================================= */

  function escapeHTML(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function createDeliveryHTML(type, isProductPage) {
    var pdpClass =
      isProductPage
        ? " yf-delivery-pdp"
        : "";

    if (type === "express") {
      return (
        '<div class="yf-delivery-text-wrap' +
          pdpClass +
          '" data-yf-delivery-type="express">' +

          '<span class="yf-delivery-text yf-delivery-text--express">' +

            '<span class="yf-delivery-label">' +
              "Earliest Delivery: " +
            "</span>" +

            '<span class="yf-delivery-value">' +
              escapeHTML(getExpressText()) +
            "</span>" +

          "</span>" +

        "</div>"
      );
    }

    if (type === "courier") {
      return (
        '<div class="yf-delivery-text-wrap' +
          pdpClass +
          '" data-yf-delivery-type="courier">' +

          '<span class="yf-delivery-text yf-delivery-text--courier">' +

            '<span class="yf-delivery-label">' +
              "Earliest Dispatch: " +
            "</span>" +

            '<span class="yf-delivery-value">' +
              escapeHTML(getCourierText()) +
            "</span>" +

          "</span>" +

        "</div>"
      );
    }

    return "";
  }

  /* =========================================================
     PRODUCT HANDLE
     ========================================================= */

  function getHandleFromURL(url) {
    if (!url) return "";

    var match = String(url).match(
      /\/products\/([^/?#]+)/i
    );

    if (!match || !match[1]) {
      return "";
    }

    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return match[1];
    }
  }

  function getCurrentProductHandle() {
    return getHandleFromURL(
      window.location.pathname
    );
  }

  function getCardHandle(card) {
    if (!card) return "";

    var productLink = card.querySelector(
      'a[href*="/products/"]'
    );

    if (!productLink) return "";

    return getHandleFromURL(
      productLink.getAttribute("href")
    );
  }

  /* =========================================================
     PRODUCT CARDS
     ========================================================= */

  function getProductCards() {
    return document.querySelectorAll(
      ".card-wrapper," +
      ".product-card," +
      ".product-grid-item," +
      ".product-item," +
      ".grid-product," +
      ".boost-pfs-filter-product-item," +
      ".boost-sd__product-item," +
      ".spf-product-card," +
      "li.grid__item"
    );
  }

  function isExcluded(element) {
    if (!element || !element.closest) {
      return false;
    }

    return Boolean(
      element.closest(
        "header," +
        "footer," +
        "nav," +
        ".header," +
        ".footer," +
        ".drawer," +
        ".menu-drawer," +
        ".mega-menu," +
        ".mobile-menu"
      )
    );
  }

  function findCardPrice(card) {
    if (!card) return null;

    return card.querySelector(
      ".card-information .price," +
      ".card__information .price," +
      ".product-card__price," +
      ".product-item__price," +
      ".boost-pfs-filter-product-item-price," +
      ".boost-sd__product-price," +
      ".price"
    );
  }

  function findCardInformation(card) {
    if (!card) return null;

    return card.querySelector(
      ".card-information," +
      ".card__information," +
      ".product-card__info," +
      ".product-item__info," +
      ".boost-pfs-filter-product-item-inner," +
      ".boost-sd__product-info"
    );
  }

  function removeCardDeliveryText(card) {
    if (!card) return;

    var elements = card.querySelectorAll(
      ".yf-delivery-text-wrap:not(.yf-delivery-pdp)," +
      ".yf-delivery-wrap:not(.yf-delivery-pdp)," +
      ".oy-delivery-badge-wrap:not(.oy-pdp)"
    );

    for (var i = 0; i < elements.length; i++) {
      elements[i].remove();
    }
  }

  function insertCardDeliveryText(card, type) {
    var priceElement = findCardPrice(card);
    var informationElement =
      findCardInformation(card);

    var html =
      createDeliveryHTML(type, false);

    if (priceElement) {
      priceElement.insertAdjacentHTML(
        "afterend",
        html
      );

      return true;
    }

    if (informationElement) {
      informationElement.insertAdjacentHTML(
        "beforeend",
        html
      );

      return true;
    }

    return false;
  }

  function processCard(card, forceUpdate) {
    if (!card || isExcluded(card)) return;

    var handle = getCardHandle(card);

    if (!handle) return;

    fetchProductTags(handle).then(function (tags) {
      if (
        !card ||
        !document.documentElement.contains(card)
      ) {
        return;
      }

      var type = getDeliveryType(tags);
      var currentText = "";

      if (type === "express") {
        currentText = getExpressText();
      }

      if (type === "courier") {
        currentText = getCourierText();
      }

      var existingText = card.querySelector(
        ".yf-delivery-text-wrap"
      );

      if (
        !forceUpdate &&
        card.dataset.yfDeliveryHandle === handle &&
        card.dataset.yfDeliveryType === type &&
        card.dataset.yfDeliveryText === currentText &&
        existingText
      ) {
        return;
      }

      removeCardDeliveryText(card);

      if (!type) {
        card.dataset.yfDeliveryHandle = "";
        card.dataset.yfDeliveryType = "";
        card.dataset.yfDeliveryText = "";
        return;
      }

      if (insertCardDeliveryText(card, type)) {
        card.dataset.yfDeliveryHandle = handle;
        card.dataset.yfDeliveryType = type;
        card.dataset.yfDeliveryText = currentText;
      }
    });
  }

  function processAllCards(forceUpdate) {
    var cards = getProductCards();

    for (var i = 0; i < cards.length; i++) {
      if (
        cards[i].querySelector(
          'a[href*="/products/"]'
        )
      ) {
        processCard(cards[i], forceUpdate);
      }
    }
  }

  /* =========================================================
     PRODUCT PAGE
     ========================================================= */

  function findProductPagePrice() {
    return document.querySelector(
      ".product__info-container .price," +
      ".product__info-wrapper .price," +
      ".product-info .price," +
      ".product-single__price," +
      ".price.price--large," +
      "[data-product-price]"
    );
  }

  function removeProductPageDeliveryText() {
    var elements = document.querySelectorAll(
      ".yf-delivery-text-wrap.yf-delivery-pdp," +
      ".yf-delivery-wrap.yf-delivery-pdp," +
      ".oy-delivery-badge-wrap.oy-pdp"
    );

    for (var i = 0; i < elements.length; i++) {
      elements[i].remove();
    }
  }

  function processProductPage() {
    if (
      window.location.pathname.indexOf(
        "/products/"
      ) === -1
    ) {
      removeProductPageDeliveryText();
      return;
    }

    var handle = getCurrentProductHandle();

    if (!handle) return;

    fetchProductTags(handle).then(function (tags) {
      var type = getDeliveryType(tags);
      var priceElement =
        findProductPagePrice();

      removeProductPageDeliveryText();

      if (!type || !priceElement) return;

      priceElement.insertAdjacentHTML(
        "afterend",
        createDeliveryHTML(type, true)
      );
    });
  }

  /* =========================================================
     AUTO TEXT UPDATE
     ========================================================= */

  function refreshVisibleText() {
    var elements = document.querySelectorAll(
      ".yf-delivery-text-wrap[data-yf-delivery-type]"
    );

    for (var i = 0; i < elements.length; i++) {
      var type = elements[i].getAttribute(
        "data-yf-delivery-type"
      );

      var valueElement =
        elements[i].querySelector(
          ".yf-delivery-value"
        );

      if (!valueElement) continue;

      if (type === "express") {
        valueElement.textContent =
          getExpressText();
      }

      if (type === "courier") {
        valueElement.textContent =
          getCourierText();
      }
    }

    var cards = getProductCards();

    for (var j = 0; j < cards.length; j++) {
      if (
        cards[j].dataset.yfDeliveryType ===
        "express"
      ) {
        cards[j].dataset.yfDeliveryText =
          getExpressText();
      }

      if (
        cards[j].dataset.yfDeliveryType ===
        "courier"
      ) {
        cards[j].dataset.yfDeliveryText =
          getCourierText();
      }
    }
  }

  /* =========================================================
     INITIALIZE
     ========================================================= */

  function initialize() {
    injectCSS();

    lastTimeKey = getTimeKey();

    processAllCards(false);
    processProductPage();
  }

  function scheduleProcessing() {
    clearTimeout(observerTimer);

    observerTimer = setTimeout(function () {
      processAllCards(false);
      processProductPage();
    }, 180);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }

  /* AJAX / FILTER / INFINITE SCROLL */

  function startObserver() {
    if (
      !window.MutationObserver ||
      !document.body
    ) {
      return;
    }

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (
          mutations[i].addedNodes &&
          mutations[i].addedNodes.length
        ) {
          scheduleProcessing();
          break;
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener(
      "DOMContentLoaded",
      startObserver,
      { once: true }
    );
  }

  /* TIME CHANGE REFRESH */

  window.setInterval(function () {
    var currentTimeKey = getTimeKey();

    if (currentTimeKey === lastTimeKey) {
      return;
    }

    lastTimeKey = currentTimeKey;
    refreshVisibleText();
  }, REFRESH_INTERVAL);

  document.addEventListener(
    "visibilitychange",
    function () {
      if (document.hidden) return;

      var currentTimeKey = getTimeKey();

      if (currentTimeKey !== lastTimeKey) {
        lastTimeKey = currentTimeKey;
        refreshVisibleText();
      }

      processAllCards(false);
      processProductPage();
    }
  );

  window.yfRefreshDeliveryBadges = function () {
    processAllCards(true);
    processProductPage();
  };
})();




  (function () {
  "use strict";

  var STORE_KEY = "oy_sitewide_badge_seed_v5";
  var TTL = 7 * 24 * 60 * 60 * 1000;
  var DISPLAY_PERCENT = 35;
  var observerTimer = null;

  var BADGES = [
    "🔥 Bestseller",
    "📈 Trending Now",
    "💎 Exclusive",
    "🆕 New Arrival",
    "⭐ Popular Pick",
    "👍 Recommended",
    "💲 Price Drop",
    "⚠️ Limited Stock",
    "🚀 Just Launched",
    "✨ Must Have",
    "🏆 Top Rated",
    "🥇 Best Choice",
    "❤️ Most Loved",
    "👥 Customer Favorite",
    "⏳ Last Few Left",
    "🚨 Selling Out",
    "🔥 Hot Demand",
    "🏅 Best in Class",
    "🖋️ Signature Edition",
    "👑 Luxury Choice",
    "🎁 Top Gifts",
    "💡 Smart Deal",
    "🏷️ Best Price Today"
  ];

  function isHomePage() {
    return location.pathname === "/" || document.body.classList.contains("template-index");
  }

  function isCollectionPage() {
    return location.pathname.indexOf("/collections/") === 0 || document.body.classList.contains("template-collection");
  }

  function isProductPage() {
    return location.pathname.indexOf("/products/") === 0 || document.body.classList.contains("template-product");
  }

  function shouldRun() {
    return isHomePage() || isCollectionPage() || isProductPage();
  }

  function injectCSSOnce() {
    if (document.getElementById("oy-sale-badge-css")) return;

    var style = document.createElement("style");
    style.id = "oy-sale-badge-css";
    style.textContent =
      ".oy-badge-host{position:relative !important;overflow:visible !important;}" +
      ".oy-sale-badge-wrap{position:absolute;top:10px;right:10px;z-index:1;pointer-events:none;}" +
      ".oy-sale-badge{" +
      "position:relative;display:inline-flex;align-items:center;justify-content:center;" +
      "padding:6px 10px;border-radius:999px;font-size:13px;font-weight:600;line-height:1.1;" +
      "white-space:nowrap;letter-spacing:.15px;color:#fff;border:0;overflow:hidden;" +
      "box-shadow:0 5px 14px rgba(0,0,0,.18);" +
      "background:linear-gradient(135deg,#ff4b6b,#ff8a3d);" +
      "transform:translateZ(0);backface-visibility:hidden;" +
      "}" +
      ".oy-sale-badge-label{position:relative;z-index:2;}" +
      ".oy-sale-badge:before{" +
      "content:'';position:absolute;top:0;left:-160%;width:68%;height:100%;" +
      "background:linear-gradient(120deg,rgba(255,255,255,0),rgba(255,255,255,.34),rgba(255,255,255,0));" +
      "transform:skewX(-24deg);animation:oyBadgeShine 5s ease-in-out infinite;z-index:1;" +
      "}" +
      "@keyframes oyBadgeShine{" +
      "0%{left:-160%;}" +
      "20%{left:140%;}" +
      "100%{left:140%;}" +
      "}" +
      "@keyframes oyPdpBadgeShake{" +
      "0%,100%{transform:translate3d(0,0,0) rotate(0deg);}" +
      "15%{transform:translate3d(-1px,0,0) rotate(-1deg);}" +
      "30%{transform:translate3d(1.4px,0,0) rotate(1deg);}" +
      "45%{transform:translate3d(-1.1px,0,0) rotate(-.85deg);}" +
      "60%{transform:translate3d(1px,0,0) rotate(.7deg);}" +
      "75%{transform:translate3d(-.6px,0,0) rotate(-.45deg);}" +
      "}" +
      ".oy-sale-badge-wrap--pdp{" +
      "animation:oyPdpBadgeShake 1.25s ease-in-out infinite;transform-origin:center center;" +
      "}" +
      "@media (max-width:749px){" +
      ".oy-sale-badge-wrap{top:8px;right:8px;}" +
      ".oy-sale-badge{padding:5px 9px;font-size:11px;}" +
      "}" +
      "@media (prefers-reduced-motion:reduce){" +
      ".oy-sale-badge:before{animation:none;}" +
      ".oy-sale-badge-wrap--pdp{animation:none !important;}" +
      "}";
    document.head.appendChild(style);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function randomSeed() {
    return Math.floor(Math.random() * 2147483647);
  }

  function loadSeedStore() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function saveSeedStore(store) {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify(store));
    } catch (e) {}
  }

  function getSeedStore() {
    var store = loadSeedStore();
    if (!store || !store.createdAt || !store.seed || Date.now() - store.createdAt > TTL) {
      store = {
        createdAt: Date.now(),
        seed: randomSeed()
      };
      saveSeedStore(store);
    }
    return store;
  }

  function hashString(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
    }
    return Math.abs(h >>> 0);
  }

  function getBadgeForHandle(handle, seed) {
    if (!handle) return null;
    var h = hashString(String(seed) + "::" + String(handle).toLowerCase());
    if (h % 100 >= DISPLAY_PERCENT) return null;
    return BADGES[h % BADGES.length];
  }

  function getBadgeGradient(text) {
    var gradients = [
      "linear-gradient(135deg,#ff4b6b,#ff8a3d)",
      "linear-gradient(135deg,#e52d27,#b31217)",
      "linear-gradient(135deg,#0f2027,#2c5364)",
      "linear-gradient(135deg,#3ccf78,#1a9347)",
      "linear-gradient(135deg,#d31b77,#d74890)",
      "linear-gradient(135deg,#ff5722,#d78001)",
      "linear-gradient(135deg,#11998e,#38ef7d)",
      "linear-gradient(135deg,#f7971e,#ffcc33)",
      "linear-gradient(135deg,#396afc,#2948ff)",
      "linear-gradient(135deg,#8e2de2,#4a00e0)",
      "linear-gradient(135deg,#1d976c,#93f9b9)",
      "linear-gradient(135deg,#c31432,#240b36)",
      "linear-gradient(135deg,#ff416c,#ff4b2b)",
      "linear-gradient(135deg,#7f00ff,#e100ff)",
      "linear-gradient(135deg,#f953c6,#b91d73)",
      "linear-gradient(135deg,#ff3c3c,#d91414)",
      "linear-gradient(135deg,#ff512f,#dd2476)",
      "linear-gradient(135deg,#00b09b,#96c93d)",
      "linear-gradient(135deg,#4b79a1,#283e51)",
      "linear-gradient(135deg,#7b4397,#dc2430)",
      "linear-gradient(135deg,#ff9966,#ff5e62)",
      "linear-gradient(135deg,#56ab2f,#a8e063)",
      "linear-gradient(135deg,#ee0979,#ff6a00)"
    ];

    var index = hashString(String(text)) % gradients.length;
    return gradients[index];
  }

  function findProductLink(scope) {
    return scope ? scope.querySelector('a[href*="/products/"]') : null;
  }

  function getHandleFromLink(link) {
    if (!link) return null;
    var href = link.getAttribute("href") || "";
    var match = href.match(/\/products\/([^\/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function isInsideBlockedSection(el) {
    return !!(
      el &&
      el.closest(
        [
          ".related-products",
          ".related-products__products",
          ".product-recommendations",
          ".recommendations",
          ".recommendations__list",
          ".recently-viewed",
          ".recently-viewed-products",
          ".complementary-products",
          ".complementary-products-contains",
          ".product__recommendations",
          ".featured-collection--product",
          ".cart",
          ".cart-drawer",
          ".drawer",
          ".mini-cart",
          ".ajaxcart",
          ".header",
          "header",
          "nav",
          "footer"
        ].join(",")
      )
    );
  }

  function ensureHostPosition(host) {
    if (!host) return;
    host.classList.add("oy-badge-host");
    try {
      if (window.getComputedStyle(host).position === "static") {
        host.style.position = "relative";
      }
    } catch (e) {
      host.style.position = "relative";
    }
  }

  function removeBadge(host) {
    if (!host) return;
    var badge = host.querySelector(".oy-sale-badge-wrap");
    if (badge) badge.remove();
  }

  function makeBadgeHTML(text, type) {
    var wrapClass = type === "pdp" ? " oy-sale-badge-wrap--pdp" : "";
    var gradient = getBadgeGradient(text);

    return (
      '<div class="oy-sale-badge-wrap' + wrapClass + '">' +
        '<span class="oy-sale-badge" style="background:' + gradient + ';">' +
          '<span class="oy-sale-badge-label">' + escapeHtml(text) + "</span>" +
        "</span>" +
      "</div>"
    );
  }

  function getCardHost(card, link) {
    return (
      card.querySelector(
        ".card__media, .card-media, .media, .card__inner, .product-card__image, .product-card__image-wrapper, .grid-product__image-wrapper, .image-wrap, .product-item__image-wrapper, .product-item__image, .lazyload-wrapper"
      ) ||
      link
    );
  }

  function isValidMainCard(card) {
    if (!card) return false;
    if (isInsideBlockedSection(card)) return false;
    if (!card.offsetParent && !isProductPage()) return false;
    return true;
  }

  function buildHomeAndCollectionItems() {
    if (!(isHomePage() || isCollectionPage())) return [];

    var nodes = document.querySelectorAll(
      ".card-wrapper, .card, .product-card, .product-item, li.grid__item, .grid__item"
    );

    var items = [];
    for (var i = 0; i < nodes.length; i++) {
      var card = nodes[i];
      if (!isValidMainCard(card)) continue;

      var link = findProductLink(card);
      var handle = getHandleFromLink(link);
      if (!handle) continue;

      var host = getCardHost(card, link);
      if (!host) continue;
      if (isInsideBlockedSection(host)) continue;

      items.push({
        type: "card",
        handle: handle,
        host: host
      });
    }

    return items;
  }

  function buildPDPItem() {
    if (!isProductPage()) return [];

    var match = location.pathname.match(/\/products\/([^\/?#]+)/i);
    var handle = match ? decodeURIComponent(match[1]) : null;
    if (!handle) return [];

    var host =
      document.querySelector(
        ".product__media-wrapper, .product__media-container, .product__media-list-wrapper, .product-gallery, .product-gallery__images, .product-single__media-group, .product__media, .featured-product__media"
      ) ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector("main");

    if (!host) return [];
    if (isInsideBlockedSection(host)) return [];

    return [
      {
        type: "pdp",
        handle: handle,
        host: host
      }
    ];
  }

  function dedupeItems(items) {
    var seen = {};
    var out = [];

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item || !item.host || !item.handle) continue;

      var key =
        item.type +
        "::" +
        item.handle +
        "::" +
        item.host.tagName +
        "::" +
        (item.host.className || "");

      if (!seen[key]) {
        seen[key] = true;
        out.push(item);
      }
    }

    return out;
  }

  function applyBadge(item, text) {
    if (!item || !item.host) return;
    removeBadge(item.host);
    if (!text) return;

    ensureHostPosition(item.host);
    item.host.insertAdjacentHTML("beforeend", makeBadgeHTML(text, item.type));
  }

  function renderAllBadges() {
    if (!shouldRun()) return;

    var seed = getSeedStore().seed;
    var items = dedupeItems(
      buildHomeAndCollectionItems().concat(buildPDPItem())
    );

    for (var i = 0; i < items.length; i++) {
      applyBadge(items[i], getBadgeForHandle(items[i].handle, seed));
    }
  }

  function init() {
    if (!shouldRun()) return;
    injectCSSOnce();
    renderAllBadges();
  }

  function scheduleRender() {
    clearTimeout(observerTimer);
    observerTimer = setTimeout(renderAllBadges, 120);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      if (!shouldRun()) return;

      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleRender();
          break;
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.oyRefreshSitewideSaleBadges = function () {
    init();
  };
})();